<template>
  <div class="container" style="overflow-y：hidden">
    <Header />
    <!-- <div class="header-box">
        <iframe  width="100%" frameborder="0" height="300" scrolling="no" style="overflow-y:hidden" src="http://10.126.6.239:9088/
" border=0></iframe>
    </div> -->
    <div class="banner">
      <div class="banner-text">
        <p>留言板</p>
        <p>Message board</p>
      </div>
    </div>
    <div class="content">
      <div class="messageBox">
        <div class="messageTypeList">
          <p class="title">留言目录</p>
          <ul>
            <li v-for="(item, i) in typeList" :key="i" :class="type == item.name ? 'active' : ''"
              @click="changeType(item)">
              {{ item.name }}</li>
            <!-- <li>就业</li>
            <li>教学</li>
            <li>学生工作</li>
            <li>生活服务</li>
            <li>人才招聘</li>
            <li>出国留学</li> -->
          </ul>
        </div>
        <div class="messageForm">
          <form class="form">
            <div class="form-item type">
              <label style="text-align: right;">类别：</label>
              <el-select v-model="formInfo.type" placeholder="请选择留言类别" style="min-width: 200px" @change="opationChange">
                <el-option v-for="item in typeList" :key="item.name" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </div>
            <div class="form-item">
              <label style="text-align: right;">标题：</label>
              <el-input v-model="formInfo.title" placeholder=""></el-input>
            </div>
            <div class="form-item">
              <label style="text-align: right;visibility:hidden;">内容：</label>
              <el-input style="color: gray;" type="textarea" :rows="5" resize="none" placeholder=""
                v-model="formInfo.qContent">
              </el-input>
            </div>
            <div class="form-item">
              <label style="text-align: right;">电话：</label>
              <el-input class="telephone" v-model="formInfo.telephone" placeholder=""></el-input>
              <span>请填写您的联系方式，以便及时收到回复</span>
            </div>
            <div class="falsephone" v-show="phoneID">请输入正确手机号</div>
            <div class="form-item" style="margin-bottom:0px">
              <label style="text-align: right;">验证码：</label>
              <el-input class="code" v-model="formInfo.code" placeholder=""></el-input>
              <canvas class="codeCanvas" id="s-canvass" @click="drawPic" width="100" height="37"></canvas>
            </div>
            <div class="falsecode" v-show="numcodeID">验证码不正确</div>
            <div class="form-item">
              <el-button class="btn" :loading="loading" @click="save">立即留言</el-button>
            </div>
          </form>
        </div>
      </div>
      <div class="mesageHistroy">
        <div class="histroyTitle">
          历史留言
        </div>
        <div class="histroyList">
          <div class="histroy-item" v-for="(item, i) in messageList" :key="i">
            <div class="item">
              <div class="top">
                <div class="item-title">{{ item.title }}</div>
                <div class="time">{{ item.createTime }}</div>
              </div>
              <div class="item-content">
                {{ item.qcontent }}
              </div>
              <div class="reply">
                <span>回复:</span>
                {{ item.reply ? item.reply.rcontent : '' }}
              </div>
            </div>
            <el-divider></el-divider>
          </div>
          <div class="addMore">
            <div @click="add()">
              <span class="el-icon-plus"></span>
              <p>MORE</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <Beian />
  </div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/header'
import Footer from '@/components/footer'
import Beian from '@/components/beian'
export default {
  name: 'message',
  data () {
    return {
      formInfo: {
        username: '',
        telephone: '',
        type: '',
        title: '',
        qContent: '',
        code: ''
      },
      typeList: [
        { name: '招生'},
        { name: '就业' },
        { name: '教学' },
        { name: '学生工作' },
        { name: '生活服务' },
        { name: '人才招聘' },
        { name: '出国留学' }
        // { name: '报考问题咨询' }
      ],
      identifyCodes: '1234567890',
      identifyCode: '',
      loading: false,
      messageList: [
        {
          title: '艺体有本科预科吗？',
          createTime: '2021-05-30 14:30:22',
          qcontent: '艺体有本科预科吗？',
          reply: {
            rcontent: '同学您好，我校没有本科预科。'
          }
        },
        {
          title: '录收，双修',
          createTime: '2021-05-30 14:30:22',
          qcontent: '请问广东艺考生，已经考过了贵校的播音与主持，也收到了录取通知书，今年参加高考估计分数400分左右，录取机率有多大?另外进入贵校后可以选择双修专业吗?',
          reply: {
            rcontent: '回复:同学您好，我校2020年在广东录取分数线为文化分255分，专业分(校考成绩)为271分2020年按广东省教育考试院文件要求，录取规则为文化专业双.上线，按文化分投档，按专业分录取。如有其他问题可以致电我校招生热线028-37666666进行咨询，欢迎报考。'
          }
        },
        {
          title: '广告专业',
          createTime: '2021-05-30 14:30:22',
          qcontent: '请问这个学校有广告这个专业吗???在线求解',
          reply: {
            rcontent: '回复:同学您好，我校没有广告专业。您可致电我校招生热线028-37666666进行电话咨询，欢迎报我校。'
          }
        },
        {
          title: '咨询播音专业',
          createTime: '2021-05-30 14:30:22',
          qcontent: '今年在河北招收播音专业的考生吗，是走联考成绩吗',
          reply: {
            rcontent: '回复:同学您好，我校2021年招生计划还未发布，请您耐心等待。计划发布后可在我校招生信息网(https://www. zs.SCujj.edu.cn)的“招生计划”中查看相关信息。我校承认联考成绩。'
          }
        }
      ],
      currentPage: 1,
      limit: 5,
      total: 0,
      type: '招生',
      phoneID: false,
      numcodeID: false
    }
  },
  components: {
    Header,
    Footer,
    Beian
  },
  mounted () {
    this.drawPic()
    this.getList()
    document.title = '留言板'
  },
  methods: {
    getList () { // 获取留言列表
      let para = {
        page: this.currentPage,
        rows: this.limit,
        type: this.type
      }
      this.$http.getMessagesList(para).then(res => {
        //console.log(res)
        this.messageList = res.list
        this.total = res.total
        this.currentPage = res.pageNum
      }).catch(err => {
        //console.error(err)
      })
    },
    changeType (item) { // 留言目录切换
      this.type = item.name
      this.currentPage = 1
      this.getList()
    },
    // 生成一个随机数
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 四个数
    makeCode (l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    // 生成一个随机的颜色
    randomColor (min, max) {
      let r = this.randomNum(min, max)
      let g = this.randomNum(min, max)
      let b = this.randomNum(min, max)
      return 'rgb(' + r + ',' + g + ',' + b + ')'
    },
    drawPic () {
      this.identifyCode = ''
      this.makeCode(4)
      let canvas = document.getElementById('s-canvass')
      let ctx = canvas.getContext('2d')
      ctx.textBaseline = 'bottom'
      // 绘制背景
      ctx.fillStyle = this.randomColor(
        255,
        255
      )
      ctx.fillRect(0, 0, 100, 37)
      // 绘制文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i)
      }
      this.drawLine(ctx)
      this.drawDot(ctx)
    },
    drawText (ctx, txt, i) {
      ctx.fillStyle = this.randomColor(0, 200)
      ctx.font =
        this.randomNum(30, 40) + 'px SimHei'
      let x = (i + 1) * (100 / (this.identifyCode.length + 1))
      let y = this.randomNum(40, 40)
      var deg = this.randomNum(-40, 40)
      // 修改坐标原点和旋转角度
      ctx.translate(x, y)
      ctx.rotate((deg * Math.PI) / 180)
      ctx.fillText(txt, 0, 0)
      // 恢复坐标原点和旋转角度
      ctx.rotate((-deg * Math.PI) / 180)
      ctx.translate(-x, -y)
    },
    drawLine (ctx) {
      // 绘制干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = this.randomColor(
          100,
          255
        )
        ctx.beginPath()
        ctx.moveTo(
          this.randomNum(0, 100),
          this.randomNum(0, 37)
        )
        ctx.lineTo(
          this.randomNum(0, 100),
          this.randomNum(0, 37)
        )
        ctx.stroke()
      }
    },
    drawDot (ctx) {
      // 绘制干扰点
      for (let i = 0; i < 40; i++) {
        ctx.fillStyle = this.randomColor(0, 255)
        ctx.beginPath()
        ctx.arc(
          this.randomNum(0, 100),
          this.randomNum(0, 37),
          1,
          0,
          2 * Math.PI
        )
        ctx.fill()
      }
    },
    add () { // 获取更多
      let para = {
        page: this.currentPage + 1,
        rows: this.limit,
        type: this.type
      }
      this.$http.getMessagesList(para).then(res => {
        //console.log(res)
        if (res.list.length > 0) {
          res.list.forEach(element => {
            this.messageList.push(element)
          })
        }
        this.total = res.total
        this.currentPage = res.pageNum
      }).catch(err => {
        //console.error(err)
      })
    },
    save () { // 留言
      this.loading = true
      if (this.formInfo.telephone === '' || this.formInfo.type === '' || this.formInfo.title === '' || this.formInfo.qContent === '' || this.formInfo.code === '') {
        this.$message({
          showClose: true,
          message: '请完善所有信息',
          type: 'error',
          customClass: 'zzindex',
          offset: 80
        })
        this.loading = false
        return false
      }
      const reg = /^1[0-9]\d{9}$/
      if (!reg.test(this.formInfo.telephone)) {
        // this.$message({
        //   showClose: true,
        //   message: '请输入正确手机号',
        //   type: 'error'
        // })
        this.phoneID = true
        this.loading = false
        return false
      } else {
        this.phoneID = false
      }
      if (this.formInfo.code !== this.identifyCode) {
        // this.$message({
        //   showClose: true,
        //   message: '验证码不正确',
        //   type: 'error'
        // })
        this.numcodeID = true
        this.loading = false
        return false
      } else {
        this.numcodeID = false
      }
      this.$http.createMessage(this.formInfo).then(res => {
        //console.log(res)
        if (res.success) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
            customClass: 'zzindex',
            offset: 80
          })
          this.formInfo = {
            name: '',
            telphone: '',
            type: '',
            title: '',
            content: '',
            code: ''
          }
          this.drawPic()
        } else {
          this.$message(
            {
              showClose: true,
              message: res.msg,
              type: 'error',
              customClass: 'zzindex',
              offset: 80
            })
        }
        this.loading = false
      }).catch(err => {
        //console.error(err)
        this.loading = false
      })
    },
    opationChange(){
      console.log('type change...');
      this.$forceUpdate();
    }
  }
}
</script>
<style>
.el-message {
  padding: 10px 10px 10px 15px !important;
  font-size: 40px
}

.messageBox .el-input__inner {
  color: gray;
  font-size: 18px;
  line-height: 23px !important;
  height: 29px !important;
  background-color: transparent !important;
  border: none;
  margin-top: 10px;
}

.hover {
  top: 0;
}

[data-v-12e95946].hover {
  top: 0 !important;
}

.el-textarea__inner {
  background-color: transparent !important;
  border: none !important;
  font-size: 20px !important;
  color: gray !important;
}

.messageBox .el-select input::-webkit-input-placeholder {
  color: #fff;
}

.messageBox .el-select .el-input__inner {
  padding-left: 0;
}

.messageForm .el-icon-arrow-up:before {
  margin-top: 0px;
  margin-left: -3px;
  content: "\e6de" !important;
  font-size: 28px;
  line-height: 42px;
  color: #e40a83;
  transform-origin: 0 0;
}

.el-select-dropdown__item {
  width: 100%;
}

.el-select-dropdown__item:hover {
  width: 100%;
  top: 0px;
}

.messageBox .el-select .el-input .el-select__caret.is-reverse {
  margin-right: 0;
  /* margin-left: -5px; */
  /* margin-top: 12px; */
  -webkit-transform: rotateZ(0deg);
  -webkit-transform-origin: center center;
  transform-origin: center center;
  transform: rotateZ(180deg);
}

.messageForm .el-input__suffix {
  transform: rotateZ(-270deg);
  text-align: center;
  color: #c0c4cc;
  -webkit-transition: all .3s linear;
  transition: all .3s linear;
  pointer-events: none;
}

@media screen and (max-width: 750px) {
  .el-textarea__inner {
    background-color: transparent !important;
    border: none !important;
    font-size: 18px !important;
    color: gray;
    height: 24vh;
    /* margin-left: -10px; */
  }

  .messageBox .el-input__inner {
    font-size: 18px;
    margin-top: 3px;
  }

  .el-input--suffix {
    margin-top: -10px;
  }
}

@media (min-width:768px) and (max-width: 1366px) {
  .messageBox .el-input__inner {
    color: gray;
    font-size: 20px;
    line-height: 25px !important;
    height: 25px !important;
    background-color: transparent !important;
    border: none;
    margin-top: 10px;
  }

  .el-textarea__inner {
    font-size: 20px !important;
  }
}

.content .messageBox .messageForm .falsephone {
  font-size: 16px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color: #6e348b;

// --
@media (max-width: 768px) {
  .content .messageBox .messageForm .falsephone {
    margin-top: 0 !important;
  }
}

@media (min-width:768px) and (max-width: 1366px) {
  .el-textarea__inner {
    font-size: 20px;
  }
}

// --
.banner {
  width: 100%;
  // height: 875px;
  height: 570px;
  overflow: hidden;
  background: url('../assets/banner.jpg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  max-height: 570px !important;
  // margin-top: 58px;
  position: relative;

  .banner-text {
    // border: 1px solid ;
    position: absolute;
    // top: 54% !important;
    top: 48% !important;
    left: 50%;
    transform: translate(-50%, -50%);
    text-shadow: 0px 10px 21px rgba(37, 37, 37, 0.65);

    p {
      &:nth-of-type(1) {
        font-size: 1.3rem;
        /* font-weight: bold; */
        color: #ffffff;
        line-height: 0px;
        // text-shadow: 0px 10px 21px rgb(37 37 37 / 65%);
      }

      &:nth-of-type(2) {
        font-size: .43rem;
        color: white;
        line-height: 0;
        margin-top: -10px;
        font-weight: bold;
      }
    }
  }
}

.content {
  font-family: “Noto Sans SC”;
  font-weight: 400;

  .messageBox {
    background: #4e0072;
    color: #fff;
    // height: 918px;
    padding-top: 70px;
    // padding-top: 224px;
    display: flex;
    // justify-content: center;
    padding-bottom: 70px;

    .messageTypeList {
      margin-left: 212px;
      margin-top: -7px;

      p {
        font-size: 41px;
        font-weight: bold;
        margin: 0 0 83px;
        text-align: right;
      }

      ul {
        list-style: none;
        margin-left: 92px;
        padding: 0;
        margin-top: 0;
        text-align: right;

        li {
          font-size: 20px;
          width: 90px;
          height: 2em;
          line-height: 2em;
          border-radius: 10px;
          padding-left: 3px;
          padding-right: 10px;
          padding-bottom: 2px;
          margin-bottom: 12px;
          cursor: pointer;

          &.active {
            background: #e4007f;
          }
        }

        li:hover {
          color: white;
        }
      }
    }

    .messageForm {
      background: #f6f2e8;
      width: 961px;
      color: #717171;
      margin-left: 224px;
      // height: 550px;
      padding: 98px 0 0 60px;

      .form-item {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        letter-spacing: 3px;

        &.type {
          margin-bottom: 30px;
        }

        label {
          width: 112px;
          font-size: 18px;
        }

        .el-select {
          background: #e2e0dd;
          width: 223px;
          height: 43px;
          line-height: 50px;
          border-radius: 10px;
          color: gray !important;
          padding-right: 17px;
          // padding-left: 44px;
          padding-left: 14px;

          input {
            font-size: 25px;
            padding-left: 0;
            line-height: 37px;
          }
        }

        .el-input {
          background: #e2e0dd;
          border-radius: 10px;
          width: 768px;
          height: 43px;
        }

        .telephone {
          width: 284px;
          height: 43px;
        }

        span {
          font-size: 16.4px;
          margin-left: 30px;
          letter-spacing: 1px;
          width: 200px;
        }

        .code {
          width: 120px;
          margin-right: 30px;
          margin-top: 0;
        }

        .el-textarea {
          background-color: #e2e0dd;
          border-radius: 10px;
          width: 768px;
          height: 197px;
        }

        .btn {
          background: #e4007f;
          color: #fff;
          // margin: 0 auto;
          margin-left: 365px;
          width: 125px;
          height: 44px;
          line-height: 44px;
          padding: 0;
          font-size: 18px;
          border-radius: 10px;
          margin-top: -6px;
        }
      }

      .falsephone {
        color: red;
        // margin: 0 auto;
        margin-left: 113px;
        margin-top: -20px;
        margin-bottom: 10px;
        font-size: 16px;
      }

      .falsecode {
        color: red;
        margin-left: 113px;
        // margin-bottom: 10px;
        margin-top: 10px;
        font-size: 16px;
      }
    }
  }

  .mesageHistroy {
    .histroyTitle {
      height: 173px;
      background: #7e45b8;
      color: #fff;
      font-size: 62.5px;
      font-weight: bold;
      text-shadow: 10px 10px 21px rgba(37, 37, 37, 0.65);
      padding-top: 73px;
      padding-left: 802px;
    }

    .histroyList {
      // height: 1560px;
      background: #f6f2e8;
      color: #717171;
      font-size: 18px;

      .histroy-item {
        width: 1399px;
        margin: 0 0 0 305px;

        .item {
          padding-left: 203px;
          padding-right: 279px;
          margin: 0 auto;
          padding-top: 30px;

          .top {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
          }

          .item-content {
            min-height: 69px;
            margin-bottom: 5px;
            line-height: 2em;
          }

          .reply {
            margin-bottom: 55px;
            line-height: 50px;

            span {
              color: #e4007f;
            }
          }
        }

        .el-divider--horizontal {
          margin: 0;
          height: 3px;
          background: #dcdcdc;
        }
      }
    }

    .addMore {
      // text-align: center;
      padding: 43px 0 75px 893px;
      opacity: 0.5;

      div {
        display: inline-block;
        cursor: pointer;
        text-align: center;
      }

      span {
        color: #e4007f;
        font-size: 35px;
      }

      p {
        margin: 15px 0 0;
        color: #e85555;
        font-size: 25px;
      }
    }
  }
}

.hover {
  top: unset;
  width: unset;
}

@media screen and (max-width: 1730px) {
  .container {
    .content {
      .messageForm {
        margin: 0 auto;
      }

      .mesageHistroy {
        .histroyTitle {
          padding-left: 746px;
        }

        .histroyList {
          .histroy-item {
            margin: 0 0 0 249px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1667px) {
  .container {
    .content {
      .messageForm {
        margin: 0 auto;

        .form-item {
          .el-input {
            width: 688px;
          }

          .telephone {
            width: 284px;
          }

          .code {
            width: 120px;
            margin-right: 30px;
          }

          .el-textarea {
            width: 688px;
          }
        }
      }

      .mesageHistroy {
        .histroyTitle {
          padding-left: 696px;
        }

        .histroyList {
          .histroy-item {
            margin: 0 0 0 189px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1610px) {
  .banner .banner-text p:nth-of-type(1) {
    font-size: 1.3rem;
    // font-weight: bold;
  }

  .banner .banner-text p:nth-of-type(2) {
    font-size: 0.43rem;
    font-weight: 700;
  }

  .container {
    .content {
      .messageTypeList {
        margin-left: 140px;
      }

      .messageForm {
        margin: 0 auto;
      }

      .mesageHistroy {
        .histroyTitle {
          padding-left: 696px;
        }

        .histroyList {
          .histroy-item {
            margin: 0 0 0 119px;
          }
        }

        .addMore {
          // text-align: center;
          padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media screen and (max-width: 1535px) {
  .container {
    .content {
      .messageTypeList {
        margin-left: 40px;
      }

      .messageForm {
        margin: 0 auto;
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            margin: 0 0 0 20px;
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media screen and (max-width: 1435px) {
  .container {
    .content {
      .messageTypeList {
        margin-left: 30px;
      }

      .messageForm {
        margin: 0 auto;
        width: 750px;
        padding: 98px 30px 0 30px;
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            width: 1099px;
            margin: 0 auto;
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }

  .histroyTitle {
    font-size: 55px;
  }
}

@media (min-width: 1060px) and (max-width: 1225px) {
  .container {
    .content {
      .messageTypeList {
        margin-left: 30px;
      }

      .banner {
        height: 430px;
      }

      .messageForm {
        margin: 0 auto;
        width: 700px;

        .form-item {
          .el-input {
            width: 558px;
          }

          .telephone {
            width: 234px;
          }

          .code {
            width: 120px;
            margin-right: 30px;
          }

          .el-textarea {
            width: 558px;
          }

          .btn {
            margin-left: 0;
            margin: 10px auto;
            width: 25vw;
          }
        }
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            width: 1099px;
            margin: 0 auto;
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1366px) {
  .content .messageBox .messageForm .form-item label {
    font-size: 20px;
  }

  // .banner .banner-text p:first-of-type{
  //   font-size: 1.3rem;
  // }
}

@media (max-width: 1366px) {
  .banner .banner-text p:nth-of-type(1) {
    font-size: 1.3rem;
    color: #ffffff;
    line-height: 0px;
  }

  .banner .banner-text p:nth-of-type(2) {
    font-size: .43rem;
    color: #ffffff;
    line-height: 0px;
  }
}

@media (min-width: 751px) and (max-width: 768px) {
  .content .messageBox .messageForm .form-item {
    &:nth-of-type(4) {
      position: relative;

      span {
        position: absolute;
        top: 46px;
        left: 82px;
      }
    }
  }

  .banner .banner-text p:nth-of-type(1) {
    // font-size: 52px;
    font-size: 1.3rem;
    text-shadow: 0px 10px 21px rgba(37, 37, 37, 0.65);
    font-weight: 400;
  }

  .banner .banner-text p:nth-of-type(2) {
    font-size: 17.2px;
    font-weight: 700;
  }

  .container {
    width: 100vw;
    overflow: hidden;

    .content {
      .messageTypeList {
        margin-left: -16px;
      }

      .messageForm {
        margin: 0 auto;
        width: 450px;
        margin-left: 30px;

        .form-item {
          .el-input {
            width: 252px;
          }

          .telephone {
            width: 252px;
          }

          .code {
            width: 120px;
            margin-right: 30px;
          }

          .el-textarea {
            width: 252px;
          }

          .btn {
            margin-left: 0;
            margin: 10px auto;
          }
        }
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            width: 100%;
            margin: 0 auto;

            .item {
              padding-left: 100px;
              padding-right: 100px;
            }
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media (min-width: 769px) and (max-width: 1060px) {
  .content .messageBox .messageForm .form-item label {
    font-size: 18px;
  }

  .banner {
    background-position: center;
    // background-size: 100% 100%;
    // height: 450px;
    position: relative;

    .banner-text {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .banner .banner-text p:nth-of-type(1) {
    font-size: 69.333px;
    // font-weight: bold;
  }

  .banner .banner-text p:nth-of-type(2) {
    font-size: 23px;
    font-weight: 700;
  }

  .container {
    .content {
      .messageTypeList {
        margin-left: -16px;
      }

      .messageForm {
        margin: 0 auto;
        width: 500px;
        padding: 15px 15px 0 15px;

        .form-item {
          .el-input {
            width: 450px;
          }

          .telephone {
            width: 180px;
          }

          .code {
            width: 120px;
            margin-right: 30px;
          }

          .el-textarea {
            width: 450px;
          }

          .btn {
            margin-left: 0;
            margin: 10px auto;
          }
        }
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            width: 100%;
            margin: 0 auto;

            .item {
              padding-left: 150px;
              padding-right: 150px;
            }
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media (min-width: 341px) and (max-width: 750px) {
  .content .messageBox .messageForm .falsephone {
    margin-left: 0;
    margin-top: 0;
    font-size: 16px;
  }

  .content .messageBox .messageForm .falsecode {
    margin-left: 0;
    margin-top: 0;
    font-size: 16px;
  }

  .container .content .mesageHistroy .histroyTitle {
    font-size: 25px;
    padding: 10px;
    box-sizing: border-box;
  }

  .container .content .mesageHistroy .addMore {
    padding: 0;
  }

  .content .messageBox .messageForm .form-item .el-select {
    height: 30px;
    width: 55%;
  }

  .container {
    width: 100vw;
    padding: 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .banner {
    width: 100vw;
    height: auto;
    // min-height: 21vh;
    min-height: 46vw;
    background-position: center;
    background-size: cover;
    margin-top: -40px;
    position: relative;

    .banner-text {
      // border: 1px solid ;
      position: absolute;
      top: 53% !important;
      left: 50%;
      transform: translate(-50%, -50%);

      p {
        &:nth-of-type(1) {
          font-size: 21px;
          font-weight: bold;
          color: #ffffff;
          line-height: 0px;
          text-align: center;
          text-shadow: 0px 10px 21px rgba(37, 37, 37, .65);
        }

        &:nth-of-type(2) {
          font-size: 14px;
          color: white;
          line-height: 0;
          margin-top: 0px;
          // margin-left: 44px;
        }
      }
    }
  }

  .content {
    width: 100%;

    .messageBox {
      padding-left: 0;
      padding-top: 0;
      text-align: center;
      flex-wrap: wrap;
      margin-bottom: -30px;

      .messageTypeList {
        padding: 0;
        margin: 0 auto;

        p {
          display: block;
          text-align: center;
          margin: 0 auto;
          font-size: 25px;
          letter-spacing: 3px;
        }

        ul {
          display: flex;
          padding: 0;
          text-align: center;
          margin: 0 auto 5px;

          li {
            font-size: 14px;
            margin: 0;
            // width: calc(100%/7);
            width: auto;
            margin-left: 0px;
            padding-left: 1px;
            padding-right: 1px;
            transform: scale(.9);
            display: inline-block;
            padding: 1px 2px;
            margin: 15px 0 0;
            line-height: 2em;
          }

          li:hover {
            color: white;
          }
        }
      }

      .messageForm {
        width: 100%;
        height: auto;
        padding: 0;
        padding-top: 4vh;

        .form {
          margin: 0 auto;

          .form-item {
            width: 100%;
            flex-wrap: wrap;
            margin-bottom: 10px;

            label {
              width: 30vw;
              font-size: 18px;
            }

            .el-input {
              width: 63%;
              height: 30px;
              font-size: 18px;
            }

            .el-textarea {
              width: 63%;
              height: 24vh;
            }

            span {
              width: 63%;
              font-size: 14px;
              text-align: left;
              margin-left: 30vw;
            }

            .code {
              width: 28%;
            }

            button {
              margin: 0 auto;
              width: auto;
              line-height: 40px;
              height: 40px;
              padding: 0;
              padding-left: 5px;
              padding-right: 5px;
            }
          }
        }
      }
    }

    .mesageHistroy {
      width: 100%;
      padding: 0;

      .histroyTitle {
        padding-top: 0;
        height: auto;
      }

      .histroyList {
        padding-top: 4vh;
        width: 100%;
        font-size: 15px;

        .histroy-item {
          width: 100%;

          .item {
            width: 100%;
            padding: 0;
            margin: 0;

            .top {
              width: 100vw;
              flex-wrap: wrap;
              padding-left: 5vw;
              padding-right: 5vw;
              box-sizing: border-box;
              margin-bottom: 10px;
              padding-top: 12px;

              .item-title {
                width: 100%;
                // text-indent:11vw;
              }

              .time {
                text-align: right;
                width: 85vw;
              }
            }

            .item-content {
              width: 100vw;
              padding-left: 5vw;
              padding-right: 5vw;
              box-sizing: border-box;
              // text-indent:11vw;
              line-height: 2em;
              margin-bottom: 0px;
            }

            .reply {
              width: 85vw;
              padding-left: 5vw;
              padding-right: 5vw;
              line-height: 28px;
              margin-bottom: 10px;
              word-wrap: break-word;
            }
          }
        }
      }
    }
  }
}

.header-box {
  width: 100%;
  position: fixed;
  height: auto;
  left: 0;
  top: 0;
  z-index: 99999;
}

@media screen and (max-width: 340px) {
  .content .messageBox .messageForm .falsephone {
    margin-left: 0;
    margin-top: 0;
  }

  .content .messageBox .messageForm .falsecode {
    margin-left: 0;
    margin-top: 0;
    font-size: 16px;
  }

  .container .content .mesageHistroy .histroyTitle {
    font-size: 25px;
    padding: 10px;
    box-sizing: border-box;
  }

  .container .content .mesageHistroy .addMore {
    padding: 0;
  }

  .content .messageBox .messageForm .form-item .el-select {
    height: 30px;
    width: 55%;
  }

  .container {
    width: 106vw;
    padding: 0;
    overflow-x: hidden;
  }

  .banner {
    width: 106vw;
    height: 185px;
    overflow-x: hidden;
    // min-height: 21vh;
    min-height: 46vw;
    background-position: center;
    background-size: cover;
    margin-top: -40px;
    position: relative;

    .banner-text {
      // border: 1px solid ;
      position: absolute;
      top: 53% !important;
      left: 50%;
      transform: translate(-50%, -50%);

      p {
        &:nth-of-type(1) {
          font-size: 21px;
          font-weight: bold;
          color: #ffffff;
          line-height: 0px;
          text-align: center;
          // text-shadow: 0px 10px 21px rgb(37 37 37 / 65%);
        }

        &:nth-of-type(2) {
          font-size: 14px;
          color: white;
          line-height: 0;
          margin-top: 0px;
          // margin-left: 44px;
        }
      }
    }
  }

  .content {
    width: 100%;

    .messageBox {
      padding-left: 0;
      padding-top: 0;
      text-align: center;
      flex-wrap: wrap;
      margin-bottom: -30px;

      .messageTypeList {
        padding: 0;
        margin: 0 auto;

        p {
          display: block;
          text-align: center;
          margin: 0 auto;
          font-size: 25px;
          letter-spacing: 3px;
        }

        ul {
          display: flex;
          padding: 0;
          text-align: center;
          margin: 0 auto;
          margin-bottom: 5px;

          li {
            font-size: 12px;
            margin: 0;
            // width: calc(100%/7);
            width: auto;
            margin-left: 0px;
            padding-left: 1px;
            padding-right: 1px;
            transform: scale(.9);
            // border: 1px solid black;
          }

          li:hover {
            color: white;
          }
        }
      }

      .messageForm {
        width: 100%;
        height: auto;
        padding: 0;
        padding-top: 4vh;

        .form {
          margin: 0 auto;

          .form-item {
            width: 100%;
            flex-wrap: wrap;
            margin-bottom: 10px;

            label {
              width: 30vw;
              font-size: 18px;
            }

            .el-input {
              width: 63%;
              height: 30px;
              font-size: 18px;
            }

            .el-textarea {
              width: 63%;
              height: 24vh;
            }

            span {
              width: 63%;
              font-size: 14px;
              text-align: left;
              margin-left: 30vw;
            }

            .code {
              width: 28%;
            }

            button {
              margin: 0 auto;
              width: auto;
              line-height: 40px;
              height: 40px;
              padding: 0;
              padding-left: 5px;
              padding-right: 5px;
            }
          }
        }
      }
    }

    .mesageHistroy {
      width: 100%;
      padding: 0;

      .histroyTitle {
        padding-top: 0;
        height: auto;
      }

      .histroyList {
        padding-top: 4vh;
        width: 100%;
        font-size: 17px;

        .histroy-item {
          width: 100%;

          .item {
            width: 100%;
            padding: 0;
            margin: 0;

            .top {
              width: 100vw;
              flex-wrap: wrap;
              padding-left: 5vw;
              padding-right: 5vw;
              box-sizing: border-box;
              margin-bottom: 10px;

              .item-title {
                width: 100%;
                // text-indent:11vw;
              }

              .time {
                text-align: right;
                width: 85vw;
              }
            }

            .item-content {
              width: 100vw;
              padding-left: 5vw;
              padding-right: 5vw;
              box-sizing: border-box;
              // text-indent:11vw;
              line-height: 2em;
              margin-bottom: 0px;
            }

            .reply {
              width: 85vw;
              padding-left: 5vw;
              padding-right: 5vw;
              line-height: 2em;
              margin-bottom: 5px;
              word-wrap: break-word;
            }
          }
        }
      }
    }
  }
}

.header-box {
  width: 100%;
  position: fixed;
  height: auto;
  left: 0;
  top: 0;
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/views/message.vue